 $(document).ready(function(){    
   const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'PKR',

      // These options are needed to round to whole numbers if that's what you want.
      //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
      //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
    });
    // Define Global Variables
        
    let showProd = '';
    let quantityLimit = [];
    let qtycounter = 0;
	let prodqty= 1;
    
    // End Define Global Variables
    document.querySelectorAll('.parent-products-type').forEach(item=>{
      let limitItem = item.querySelector('.cs-product-item:first-child');
      if (limitItem){
        var limit = limitItem.getAttribute('data-limit');
        $(item).attr('data-limit',limit)

      }
      if(limitItem){
        var limit = limitItem.getAttribute('data-limit');
		
        let itemTitle = $(item).find('.comb-header h1').html() + `<span style="font-size:14px"> ( Choose any ${limit} )</span>`
        $(item).find('.comb-header h1').html(itemTitle)
      }

      if( item.querySelectorAll('.cs-product-item').length < 1 ){
        item.style.display="none"
      }
    })
    
    
    
  	// Make List of limits of different combos
  
    ;
  	// End Make List of limits of different combos

// Get packages sizes and types details
let package, size, type = '';

// Get package details
$('.package-selector-body input').on('change', function() {

   
    $('.cs-product-item').removeClass('csactive');
    $('.cs-product-item').css({
        opacity: '1',
        pointerEvents: 'auto'
    });


    if ($(this).val() != 'null') {
        $('.cs-size-selector').show();
        package = $(this).val().replace(' ', '-');
        $('.Size-Selector').show();
        $('.size-options').hide();
        $(`.opt-${package}`).show();
        if (size) {
            var fileUrl = `//shopatshams.com.pk/cdn/shop/files/`;
            var newUrl = `${fileUrl}${package}-${size}.jpg`;
            $('.ds-package-image').show();
            $('.ds-package-image').attr('src', newUrl);
            $('.products-wrapper').addClass('ds-none');
            $(`.ds-${package}-${size}`).removeClass('ds-none');
            $(`.ds-${package}-${size} .parent-products-type`).addClass('active-proudcts-list');

            document.querySelectorAll('.parent-products-type').forEach(item => {
                if (item.querySelectorAll('.cs-product-item').length < 1) {
                    item.classList.add('ds-none')
                }
            })
            qtycounter = 0;
            showProd = package + '-' + size;
            $('.cstm-desc-package').hide()
            $(`.desc-${package}-${size}`).show();
        }
    }
})
// End Get package details
 var totalprice = 0;
// Get sizes details
$('.ds-size-item input').on('change', function() {
    $('.cs-product-item').removeClass('csactive');
    $('.default-Selector').show();
    $('.cs-product-item').css({
        opacity: '1',
        pointerEvents: 'auto'
    });
        var pkg = $('.ds-package-item input:checked').val().toLowerCase();
        size = $(this).val().toLowerCase();
        var basketprice = 0; 
        var totalprice = 0;
        basketprice = parseFloat($(`.${package}-${size}`).data('price'))
        totalprice = totalprice + basketprice; 
        $('.pdp-totalprice').text(`${formatter.format(totalprice)}`)
    if ($(this).val() != 'null') {
        //         $('.cs-type-selector').show();
        size = $(this).val().replace(' ', '-');
        var fileUrl = `//shopatshams.com.pk/cdn/shop/files/`;
        var newUrl = `${fileUrl}${package}-${size}.jpg`;
        $('.ds-package-image').show();
        $('.products-wrapper').addClass('ds-none');
        $(`.ds-${package}-${size}`).removeClass('ds-none');
        $(`.ds-${package}-${size} .parent-products-type`).addClass('active-proudcts-list');
         
        
        $('.cstm-desc-package').hide()
        $(`.desc-${package}-${size}`).show();
        document.querySelectorAll('.parent-products-type').forEach(item => {
            if (item.querySelectorAll('.cs-product-item').length < 1) {
                item.classList.add('ds-none')
            }
        })
        $('.ds-package-image').attr('src', newUrl);
        qtycounter = 0;
        showProd = package + '-' + size;
    }
})
$('.ds-default-item input').on('change',function(){
    var pkg = '';
    var size = '';
    var pkg = $('.ds-package-item input:checked').val().toLowerCase();
    var size = $('.ds-size-item input:checked').val().toLowerCase();
    $('.cs-add-product-buttons').show();
    
    if($('.ds-default-item input:checked').length > 0 && $('.ds-default-item input:checked').val() != 'desired' ){
        $(`.ds-${pkg}-${size}`).find('.cs-product-item').removeClass('csactive');
        $(`.ds-${pkg}-${size}`).find('.cs-product-item').css({pointerEvents:'auto',opacity:'1',cursor:'pointer'});
        $(`.ds-${pkg}-${size}`).find('.default-product').addClass('csactive')
        $('.cs-product-item').css({pointerEvents:'none'});
        $('.cs-product-item:not(.default-product.csactive)').hide();
        $('.cs-products-area').show();
        $('.label-ds-notes,.ds-notes').show();
        var pkg = $('.ds-package-item input:checked').val().toLowerCase();  
            var size = $('.ds-size-item input:checked').val().toLowerCase();
            var basketprice = 0; 
            var totalprice = 0;
            basketprice = parseFloat($(`.${package}-${size}`).data('price'))
            totalprice = totalprice + basketprice; 
            $('.cs-product-item.csactive').each(function(index,im){
              totalprice += parseFloat($(im).data('price'));
            }); 
            console.log(totalprice)
            $('.pdp-totalprice').text(`${formatter.format(totalprice)}`)  
              
    }
    else{
      $('.cs-product-item').css({pointerEvents:'auto'});
        $('.cs-product-item:not(.default-product.csactive)').css({display:'flex'});
        $(`.ds-${pkg}-${size}`).find('.default-product').removeClass('csactive');
        $('.cs-products-area').show()
        $('.label-ds-notes,.ds-notes').hide();
        var pkg = $('.ds-package-item input:checked').val().toLowerCase();  
            var size = $('.ds-size-item input:checked').val().toLowerCase();
            var basketprice = 0; 
            var totalprice = 0;
           basketprice = parseFloat($(`.${package}-${size}`).data('price'))
              
            totalprice = totalprice + basketprice; 
               $('.pdp-totalprice').text(`${formatter.format(totalprice)}`)  
    }
         var selectedBucket = pkg + '-' + size;   
      if(selectedBucket == 'basket-mini' || selectedBucket == 'bucket-superbe' || selectedBucket == 'bucket-petit' ){
              $('.label-ds-notes').hide();
      }
})
$('.cs-product-item').on('click', function() {
    showProd = $(this).data('showprod');
    totalprice = 0;
    var pkg = $('.ds-package-item input:checked').val().toLowerCase();
    var size = $('.ds-size-item input:checked').val().toLowerCase();
    var basketprice = 0; 
    basketprice = parseFloat($(`.${package}-${size}`).data('price'))
    totalprice = totalprice + basketprice; 
    
    $(this).toggleClass('csactive');
    $('.cs-product-item.csactive').each(function(index,im){
      totalprice += parseFloat($(im).data('price'));
      $('.pdp-totalprice').text(`${formatter.format(totalprice)}`)
    });
    if ($(`.${showProd} .csactive`).length >= $(this).data('limit')) {
        $(`.${showProd} .cs-product-item:not(.csactive)`).css({
            pointerEvents: 'none',
            cursor: 'no-drop',
            opacity: '0.5'
        })
    } else {
        $(`.${showProd} .cs-product-item`).css({
            pointerEvents: 'auto',
            cursor: 'pointer',
            opacity: '1'
        })
    }
    if ($('.cs-product-item').length > 0) {
        $('.cs-add-product-buttons').css({
            display: 'flex'
        });
    } else {
        $('.cs-add-product-buttons').hide();
    }

    // Limit counter

})

$('.cs-product-item.optional-product').on('click',function(){
  if($(this).hasClass('csactive')){
  	$('.label-ds-notes, .ds-notes').show();
    $('.ds-notes').attr('required','')
  }
  else{
    $('.label-ds-notes, .ds-notes').hide();
    $('.ds-notes').removeAttr('required')
  }
})

// Function to generate a unique identifier for a bundle


$('.addtobtn').on('click', function() {


let childProducts=[];
let allSelectedProducts = document.querySelectorAll('.active-proudcts-list:not(.ds-optional):not(.ds-none)');
let formData = [];
var parentProd = {};
let compareLimit = '';
allSelectedProducts.forEach(item => {
    let limit = parseInt($(item).data('limit'));
    console.log(item);
    var sselectedItems = item.querySelectorAll('.cs-product-item.csactive');
        if (limit != sselectedItems.length) {
            compareLimit += 'false'
        } else {
            compareLimit += 'true'
        }
})
allSelectedProducts.forEach(item => {
    let limit = $(item).data('limit');
    if (limit) {
        let selectedItems = item.querySelectorAll('.cs-product-item.csactive');
        if (compareLimit.includes('false')) {
            if (selectedItems.length < limit || selectedItems.length >= 0) {
                $('.ds-error-popup-wrapper').fadeIn();
                setTimeout(function() {
                    $(item).find('.cs-product-item:not(.csactive)').addClass('cserror')
                    $('.ds-error-popup-wrapper').fadeOut();
                }, 5000)
            } else if (selectedItems.length == 0) {
                $(item).find('.cs-product-item').addClass('cserror')
            } else if (selectedItems.length == limit) {
                $(item).find('.cs-product-item').removeClass('.cserror')
            }
        } else {
            $('.csactive').find('.cs-product-item').removeClass('.cserror')

            if ($('#dsDeliveryDate').val() == '' || $('#dsDeliveryDate').val() == null) {
                $('.timeslot-error').show();
            } else {
                let checkItems = ``;
                $('.csactive').each(function(index, item) {
                    if (Number($(item).data('avqty')) < Number($('#csqty').val())) {
                        checkItems += `false`
                    } else if (Number($(item).data('avqty')) > Number($('#csqty').val())) {
                        checkItems += `true`
                    }
                })
                if (checkItems.includes('false')) {
                    $('.ds-error-popup-wrapper').fadeIn();
                    setTimeout(function() {
                        $('.ds-error-popup-wrapper').fadeOut();
                    }, 5000)
                } else {
                    let data = [];
                    $('.csactive').each(function(index, item) {
                        var vid = Number($(item).data('variantid'));
                        var avQty = Number($(item).data('avqty'))
                        let qty = $('#csqty').val() * 1;

                        avQty < qty ? qty = avQty : false;
                        var it = {
                            id: vid,
                            quantity: qty,
                            properties:{
                              "For" : `${package.toUpperCase()} ${size.toUpperCase()}`,
                            }
                        };
                        
                        data.push(it)
                    })
                    console.log(package +'='+size)
                    console.log(data);
                    let basket = {
                        id: Number($(`.${package}-${size}`).data('id')),
                        quantity: $('#csqty').val() * 1,
                        properties:{
                        "Notes":$('.ds-notes').val(),
                        "Delivery Date":$('#dsDeliveryDate').val(),
                        "Special Instructions":$('.ds-instructions').val()
                      }
                    };
                    childProducts = data;
                    let bundleUnique = "";
                    data.forEach(product=>{
                      bundleUnique =bundleUnique + product.id + ":"
                    })
                    bundleUnique = bundleUnique.slice(0, -1);
                    basket.properties["basket_item_keys"] = bundleUnique+":"+basket.id; 
                    data.push(basket)
                    parentProd = basket;
                    formData = {
                        items: data
                    } 
                  
                }

            }
        }
    }
})

parentProd['total'] = totalprice;
var parentProducts = [];




console.log(formData);

if(formData.items){
fetch('/cart/add.js', {
    method: 'POST',
    headers: {
        'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
})
.then(response => {
    console.log(response)
    if(response.status == 200){
        
        $('.quantity-error').css({backgroundColor:'#fff!important'});
        $('.quantity-error').html(`<p style="color:fff!important">Added to cart</p>`)
        $('.quantity-error').addClass('dis');
        setTimeout(function(){
          window.location = '/cart' 
        },1000)
        $('.ds-error-popup-wrapper').fadeOut();
     }
     else{
       $('.ds-error-popup-wrapper').fadeIn();
      setTimeout(function(){
        $('.ds-error-popup-wrapper').fadeOut();
      },5000)
     }
    return response.json();
}).then(response => { 
  console.log(response)
})
.catch((error) => {
  console.log(error)
    $('.ds-error-popup-wrapper').fadeIn();
    
});
}
else{
  $('.ds-error-popup-wrapper').fadeIn();
  setTimeout(function(){
    $('.ds-error-popup-wrapper').fadeOut();
  },5000)
}
})

        var today = new Date();
        var dd = String(today.getDate()+3).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0');
        var yyyy = today.getFullYear();
        var date = new Date(), y = date.getFullYear(), m = date.getMonth();
        var lastDay = new Date(y, m + 1, 0);
        if(Number(dd) >= lastDay.getDate()){
          dd = Number(dd) - lastDay.getDate()
          mm = String(today.getMonth() + 2).padStart(2, '0')
        }
        today = yyyy + '-' + mm + '-' + dd;
  $('#dsDeliveryDate').daterangepicker({
    singleDatePicker: true,
    minDate: new Date(today),
    isInvalidDate:function dscheckDate(date){
      if(date._d.toString().includes('Sun') || date._d.toString().includes('Sat') ){
        return true
      }
    }
  });
  })